module.exports = __webpack_public_path__ + "static/media/gts10.68ca9275.png";